import { createMetricsFactory } from 'metrics-js';
import { getIsAcceptanceTest } from './envUtils';

// `| undefined` is honest about the pre-bootstrap state — call sites
// must guard with `Metrics?.counter(...)` because `setupMetricsFactory`
// runs on app boot, not at module eval.
export let Metrics;
export const setupMetricsFactory = namespace => {
  Metrics = createMetricsFactory(namespace, {
    dimensions: {
      isAcceptanceTest: `${getIsAcceptanceTest()}`
    }
  });
};